/**
 * Directive: summernote
 * wrapper for angular-summernote library
 */
angular.module('acme.common.directive.summernote', [])
.directive('summernote', [function() {

    return {
      restrict: 'EA',
      link: function($scope, $element, $attrs) {
        $('.summernote').on('summernote.init', function() {
          var noteEditor = $('.note-editor');

            noteEditor
            .find('button')
            .attr('aria-label', function(){

              var text = '';

              if ($(this).hasClass('dropdown-toggle')) {
                text += 'Menu, ';
              }

              text += $(this).data('original-title');

              var currentFontSize = $(this).find('.note-current-fontsize');
              if (currentFontSize.length > 0) {
                text += ', ' + currentFontSize.text();
              }

              return text;
            })
            .attr('tabindex', '0');

            noteEditor.find('.dropdown-menu a').attr('role', 'menuitem');

            noteEditor.find('.modal input').each(function(index, item) {
              $(item).attr('id', 'summernote-modal-label-' + index);
            });

            noteEditor.find('.modal label').each(function(index, item) {
              if ($('#summernote-modal-label-' + index).length > 0) {
                $(item).attr('for', 'summernote-modal-label-' + index);
              }
            });

            noteEditor.find('div.dropdown-menu').each(function(index, item) {
              var menuItems = $(item).find('li').wrapAll('<ul role="menu" />');
            });

            $('.note-popover').find('button').attr('aria-label', function() {
              return $(this).data('original-title');
            });

            $('.templates-create-description').find('.note-editable').attr('aria-label', 'Event description');
            $('.templates-create-description').find('.note-codable').attr('aria-label', 'Event description');

            $('.programs-instance-edit').find('.note-editable').attr('aria-label', 'Event description');
            $('.programs-instance-edit').find('.note-codable').attr('aria-label', 'Event description');
        });
      }

    };

}]);
